type LoadingHandler = () => void;

let globalIncrement: LoadingHandler | null = null;
let globalDecrement: LoadingHandler | null = null;

export function setGlobalLoadingHandlers(
  increment: LoadingHandler | null,
  decrement: LoadingHandler | null
) {
  globalIncrement = increment;
  globalDecrement = decrement;
}

export function incrementGlobalLoading() {
  if (globalIncrement) {
    globalIncrement();
  }
}

export function decrementGlobalLoading() {
  if (globalDecrement) {
    globalDecrement();
  }
}
